// src/components/landing/LandingStyles.tsx
import React from "react";

export function LandingStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Anton&family=Manrope:wght@400;500;600;700;800&display=swap');
      .adroj-landing { font-family: 'Manrope', ui-sans-serif, system-ui, sans-serif; }
      .adroj-landing .font-display { font-family: 'Anton', sans-serif; letter-spacing: 0.01em; }
      .adroj-range::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        pointer-events: auto;
        height: 16px;
        width: 16px;
        border-radius: 9999px;
        background: #fff;
        border: 3px solid #EB4A2D;
        box-shadow: 0 1px 3px rgba(15,23,42,0.25);
        cursor: pointer;
      }
      .adroj-range::-moz-range-thumb {
        pointer-events: auto;
        height: 16px;
        width: 16px;
        border-radius: 9999px;
        background: #fff;
        border: 3px solid #EB4A2D;
        box-shadow: 0 1px 3px rgba(15,23,42,0.25);
        cursor: pointer;
      }
      @keyframes fadein { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
    `}</style>
  );
}